import type { ICustomCategoriesAndShared } from "app/services/category/userCustomCategoryService";
import type { Action } from "redux"; // adjust this import if you're using a different Action type

// Extend Action with payload typing
interface CustomCategoriesAction extends Action {
    type: string;
    payload?: ICustomCategoriesAndShared;
}

interface ICustomCategoriesState {
    isLoading: boolean;
    customCategories: ICustomCategoriesAndShared | null;
}

const initialState: ICustomCategoriesState = {
    isLoading: false,
    customCategories: null,
};

export function customCategories(
    state: ICustomCategoriesState = initialState,
    action: CustomCategoriesAction,
): ICustomCategoriesState {
    switch (action.type) {
        case "CUSTOM_CATEGORIES_REQUEST":
            return {
                ...state,
                isLoading: true,
            };
        case "CUSTOM_CATEGORIES_SUCCESS":
            return {
                ...state,
                isLoading: false,
                customCategories: action.payload ?? null,
            };
        default:
            return state;
    }
}
